<h1 class="title">Utlösta larm</h1>
<p class="brodtext-medium-14">
  Tidiga varningar ger respektive deltagande kliniskt mikrobiologiskt laboratorium information om när ett visst <br>
  smittämne eller antibiotikaresistens identifierats i ett fynd. Genom användning av fördefinierade filter för tidig <br>
  varning sammanställs det varje dag en lista med signaler för tidiga varningar. De fördefinierade filtren har tagits <br>
  fram av Svebargruppen i samarbete med deltagande laboratorium. Nedan ses en lista på idag aktiva tidiga varningar. <br>
  Dessa kan visas per laboratorium eller per tidig varning med hjälp av de olika flikarna.
</p>
<p-tabs
  *ngIf="sessionService.isInternUser" value="utlöstaLarm" (valueChange)="toggleShowBy($event === 'perLab' ? 'labCode' : 'kriteriaName')"
>
  <p-tablist>
    <p-tab value="perLab" > Visa per laboratorium</p-tab>
    <p-tab value="perLarm" > Visa per larmkriterium</p-tab>
  </p-tablist>
</p-tabs>

<p-tabs
  *ngIf="!sessionService.isInternUser" (valueChange)="toggleShowBy($event === 'visaPerLarmK' ? 'kriteriaName' : 'provId')"
>

  <p-tablist>
    <p-tab value="visaPerLarmK" >Visa per larmkriterie</p-tab>
    <p-tab value="visaPerProv" >Visa per provId</p-tab>
  </p-tablist>
</p-tabs>
<app-table [config]="tableConfig" [dateHeaderTemplate]="dateHeader"></app-table>
<ng-template #dateHeader>
  <tr>
    <th colspan="4">
      <p-carousel
        [value]="dates"
        [numVisible]="8"
        [numScroll]="6"
        [showIndicators]="false"
        [page]="activeIndex > 6 ? 1 : 0"
        [circular]="false"
      >
        <ng-template let-date pTemplate="item">
          <span class="date-tab" [class.selected]="activeIndex === dates.indexOf(date)" (click)="getDate(date)">
            {{ date }}
          </span>
        </ng-template>
      </p-carousel>
    </th>
  </tr>
</ng-template>
